/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

export default class UiDropdownLinkComponent extends Component {
  get models() {
    return this.args.models || [];
  }
}
